export const allEdges = [
  {"from": 1, "to": 2, "label": "includes"},
  {"from": 1, "to": 13, "label": "includes"},
  {"from": 1, "to": 40, "label": "includes"},
  {"from": 1, "to": 54, "label": "includes"},
  {"from": 1, "to": 73, "label": "includes"},
  {"from": 1, "to": 92, "label": "includes"},
  {"from": 1, "to": 100, "label": "includes"},
  {"from": 2, "to": 3, "label": "includes"},
  {"from": 2, "to": 4, "label": "includes"},
  {"from": 2, "to": 11, "label": "includes"},
  {"from": 2, "to": 12, "label": "includes"},
  {"from": 2, "to": 142, "label": "includes"},
  {"from": 2, "to": 143, "label": "includes"},
  {"from": 2, "to": 144, "label": "includes"},
  {"from": 4, "to": 5, "label": "includes"},
  {"from": 4, "to": 6, "label": "includes"},
  {"from": 4, "to": 7, "label": "includes"},
  {"from": 4, "to": 8, "label": "includes"},
  {"from": 4, "to": 9, "label": "includes"},
  {"from": 4, "to": 10, "label": "includes"},
  {"from": 4, "to": 130, "label": "includes"}, 
  {"from": 5, "to": 138, "label": "includes"},
  {"from": 5, "to": 145, "label": "includes"},
  {"from": 5, "to": 135, "label": "includes"},
  {"from": 5, "to": 137, "label": "includes"},
  {"from": 6, "to": 136, "label": "includes"},
  {"from": 6, "to": 149, "label": "includes"},
  {"from": 6, "to": 152, "label": "includes"},
  {"from": 6, "to": 153, "label": "includes"},
  {"from": 10, "to": 130, "label": "includes"},
  {"from": 10, "to": 132, "label": "has component"},
  {"from": 10, "to": 133, "label": "includes"},
  {"from": 10, "to": 134, "label": "uses"},
  {"from": 10, "to": 161, "label": "uses technique"},
  {"from": 10, "to": 162, "label": "uses technique"},
  {"from": 10, "to": 163, "label": "uses technique"},
  {"from": 10, "to": 164, "label": "uses"},
  {"from": 10, "to": 14, "label": "includes"},
  {"from": 13, "to": 15, "label": "includes"},
  {"from": 13, "to": 16, "label": "includes"},
  {"from": 13, "to": 19, "label": "includes"},
  {"from": 13, "to": 20, "label": "includes"},
  {"from": 13, "to": 21, "label": "includes"},
  {"from": 13, "to": 26, "label": "includes"},
  {"from": 13, "to": 139, "label": "includes"},
  {"from": 13, "to": 141, "label": "includes"},
  {"from": 14, "to": 27, "label": "enables"},
  {"from": 14, "to": 43, "label": "uses"},
  {"from": 14, "to": 130, "label": "is type of"},
  {"from": 16, "to": 17, "label": "includes variant"},
  {"from": 16, "to": 18, "label": "includes variant"},
  {"from": 21, "to": 22, "label": "includes"},
  {"from": 21, "to": 23, "label": "includes"},
  {"from": 21, "to": 24, "label": "includes"},
  {"from": 21, "to": 25, "label": "includes"},
  {"from": 21, "to": 27, "label": "includes"},
  {"from": 21, "to": 154, "label": "includes"},
  {"from": 26, "to": 27, "label": "includes"},
  {"from": 26, "to": 32, "label": "includes"},
  {"from": 26, "to": 36, "label": "includes"},
  {"from": 26, "to": 38, "label": "includes"},
  {"from": 27, "to": 28, "label": "example: GPT-4"},
  {"from": 27, "to": 29, "label": "example: Claude"},
  {"from": 27, "to": 30, "label": "example: Gemini"},
  {"from": 27, "to": 31, "label": "example: Llama"},
  {"from": 27, "to": 14, "label": "uses"},
  {"from": 27, "to": 55, "label": "requires"},
  {"from": 27, "to": 42, "label": "uses"},
  {"from": 32, "to": 33, "label": "example"},
  {"from": 32, "to": 34, "label": "example"},
  {"from": 32, "to": 35, "label": "example"},
  {"from": 36, "to": 37, "label": "example"},
  {"from": 38, "to": 39, "label": "example"},
  {"from": 40, "to": 41, "label": "includes"},
  {"from": 40, "to": 45, "label": "includes"},
  {"from": 40, "to": 46, "label": "includes"},
  {"from": 40, "to": 51, "label": "includes"},
  {"from": 40, "to": 52, "label": "includes"},
  {"from": 40, "to": 53, "label": "includes"},
  {"from": 41, "to": 42, "label": "includes"},
  {"from": 41, "to": 43, "label": "includes"},
  {"from": 41, "to": 44, "label": "includes"},
  {"from": 46, "to": 47, "label": "uses"},
  {"from": 46, "to": 48, "label": "uses"},
  {"from": 46, "to": 49, "label": "uses"},
  {"from": 46, "to": 50, "label": "uses"},
  {"from": 52, "to": 46, "label": "uses"},
  {"from": 52, "to": 27, "label": "uses"},
  {"from": 52, "to": 43, "label": "uses"},
  {"from": 52, "to": 44, "label": "uses"},
  {"from": 52, "to": 48, "label": "uses"},
  {"from": 52, "to": 50, "label": "uses"},
  {"from": 54, "to": 55, "label": "includes"},
  {"from": 54, "to": 56, "label": "includes"},
  {"from": 54, "to": 60, "label": "includes"},
  {"from": 54, "to": 64, "label": "includes"},
  {"from": 54, "to": 68, "label": "includes"},
  {"from": 54, "to": 70, "label": "includes"},
  {"from": 54, "to": 71, "label": "includes"},
  {"from": 54, "to": 72, "label": "includes"},
  {"from": 54, "to": 131, "label": "includes"},
  {"from": 54, "to": 161, "label": "includes"},
  {"from": 54, "to": 162, "label": "includes"},
  {"from": 54, "to": 163, "label": "includes"},
  {"from": 54, "to": 164, "label": "includes"},
  {"from": 56, "to": 57, "label": "includes"},
  {"from": 56, "to": 58, "label": "includes"},
  {"from": 56, "to": 59, "label": "includes"},
  {"from": 60, "to": 61, "label": "includes"},
  {"from": 60, "to": 62, "label": "includes"},
  {"from": 60, "to": 63, "label": "includes"},
  {"from": 60, "to": 93, "label": "supports"},
  {"from": 64, "to": 65, "label": "includes"},
  {"from": 64, "to": 66, "label": "includes"},
  {"from": 64, "to": 67, "label": "includes"},
  {"from": 68, "to": 69, "label": "uses metric"},
  {"from": 73, "to": 74, "label": "includes"},
  {"from": 73, "to": 80, "label": "includes"},
  {"from": 73, "to": 85, "label": "includes"},
  {"from": 74, "to": 75, "label": "includes"},
  {"from": 74, "to": 76, "label": "includes"},
  {"from": 74, "to": 77, "label": "includes"},
  {"from": 74, "to": 78, "label": "includes"},
  {"from": 74, "to": 79, "label": "includes"},
  {"from": 80, "to": 81, "label": "includes"},
  {"from": 80, "to": 82, "label": "includes"},
  {"from": 80, "to": 83, "label": "includes"},
  {"from": 80, "to": 84, "label": "includes"},
  {"from": 85, "to": 86, "label": "includes"},
  {"from": 85, "to": 87, "label": "uses"},
  {"from": 85, "to": 88, "label": "includes"},
  {"from": 85, "to": 89, "label": "includes"},
  {"from": 85, "to": 90, "label": "uses"},
  {"from": 85, "to": 91, "label": "uses"},
  {"from": 92, "to": 93, "label": "includes"},
  {"from": 92, "to": 94, "label": "includes"},
  {"from": 92, "to": 95, "label": "addresses"},
  {"from": 92, "to": 96, "label": "addresses"},
  {"from": 92, "to": 97, "label": "includes"},
  {"from": 92, "to": 98, "label": "includes"},
  {"from": 92, "to": 99, "label": "includes"},
  {"from": 100, "to": 101, "label": "includes"},
  {"from": 100, "to": 105, "label": "includes"},
  {"from": 100, "to": 108, "label": "includes"},
  {"from": 100, "to": 112, "label": "includes"},
  {"from": 100, "to": 115, "label": "includes"},
  {"from": 100, "to": 118, "label": "includes"},
  {"from": 100, "to": 121, "label": "includes"},
  {"from": 100, "to": 124, "label": "includes"},
  {"from": 100, "to": 127, "label": "includes"},
  {"from": 101, "to": 102, "label": "includes"},
  {"from": 101, "to": 103, "label": "includes"},
  {"from": 101, "to": 104, "label": "includes"},
  {"from": 105, "to": 106, "label": "includes"},
  {"from": 105, "to": 107, "label": "includes"},
  {"from": 108, "to": 109, "label": "includes"},
  {"from": 108, "to": 110, "label": "includes"},
  {"from": 108, "to": 111, "label": "includes"},
  {"from": 112, "to": 113, "label": "includes"},
  {"from": 112, "to": 114, "label": "includes"},
  {"from": 118, "to": 119, "label": "includes"},
  {"from": 118, "to": 120, "label": "includes"},
  {"from": 121, "to": 122, "label": "includes"},
  {"from": 121, "to": 123, "label": "includes"},
  {"from": 124, "to": 125, "label": "includes"},
  {"from": 124, "to": 126, "label": "includes"},
  {"from": 127, "to": 128, "label": "includes"},
  {"from": 127, "to": 129, "label": "includes"},
  {"from": 130, "to": 133, "label": "includes"},
  {"from": 130, "to": 132, "label": "uses"},
  {"from": 130, "to": 134, "label": "uses"},
  {"from": 130, "to": 165, "label": "uses"},
  {"from": 133, "to": 132, "label": "uses"},
  {"from": 133, "to": 134, "label": "uses"},
  {"from": 135, "to": 138, "label": "related to"},
  {"from": 139, "to": 140, "label": "includes"},
  {"from": 139, "to": 27, "label": "uses"},
  {"from": 139, "to": 14, "label": "uses"},
  {"from": 139, "to": 158, "label": "includes"},
  {"from": 139, "to": 159, "label": "includes"},
  {"from": 139, "to": 160, "label": "includes"},
  {"from": 141, "to": 15, "label": "uses"},
  {"from": 141, "to": 155, "label": "includes"},
  {"from": 141, "to": 156, "label": "includes"},
  {"from": 145, "to": 146, "label": "includes"},
  {"from": 145, "to": 147, "label": "includes"},
  {"from": 145, "to": 148, "label": "includes"},
  {"from": 145, "to": 160, "label": "enables"},
  {"from": 149, "to": 150, "label": "includes"},
  {"from": 149, "to": 151, "label": "includes"},
  {"from": 164, "to": 165, "label": "optimized by"},
  {"from": 100, "to": 167, "label": "includes"},
  {"from": 100, "to": 117, "label": "includes"},
  {"from": 100, "to": 157, "label": "includes"},
  {"from": 100, "to": 116, "label": "includes"},
  {"from": 100, "to": 168, "label": "includes"},
  {"from": 100, "to": 169, "label": "includes"},
  {"from": 100, "to": 170, "label": "includes"}
];